'use client';

import { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage } from 'components/shared/custom-image';
import v3 from 'components/landing/v3/v3.module.css';
import { useTextReveal } from './hooks/useTextReveal';
import styles from './NoSubscription.module.css';

/* The copy, which fades up as the other section heads do, then the hand
   under it, its forearm fading into the white section below. The hand is
   static: no pin and no scroll animation. */
export const NoSubscription = () => {
  const t = useTranslations('whyUltrahuman');
  const sectionRef = useRef<HTMLElement>(null);
  useTextReveal(sectionRef);

  return (
    <section
      ref={sectionRef}
      id="your-data"
      className={styles.section}
      aria-labelledby="why-ultrahuman-no-subscription-title"
    >
      <div className={styles.copy}>
        <h2
          id="why-ultrahuman-no-subscription-title"
          className={`${v3.sectionTitle} ${styles.title}`}
          data-reveal
        >
          {t('noSubscription.title')}
        </h2>
        <p className={styles.body} data-reveal>
          {t('noSubscription.body')}
        </p>
      </div>
      <div className={styles.hand}>
        <CustomImage
          src="web_v2/why-ultrahuman/hand-with-ring.png"
          alt={t('noSubscription.imageAlt')}
          fill
          sizes="(min-width: 992px) 690px, 130vw"
        />
        <span className={styles.blend} aria-hidden />
      </div>
    </section>
  );
};
